export var SaleType;
(function (SaleType) {
    /** Default value, can be used when no specific sale is associated. */
    SaleType["SALE_TYPE_UNSPECIFIED"] = "SALE_TYPE_UNSPECIFIED";
    SaleType["CYBER_MONDAY"] = "CYBER_MONDAY";
    SaleType["NOVEMBER_SALE"] = "NOVEMBER_SALE";
    SaleType["BLACK_FRIDAY"] = "BLACK_FRIDAY";
    SaleType["DEVELOPER_SALE"] = "DEVELOPER_SALE";
})(SaleType || (SaleType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["DISCOUNT_TYPE_UNSPECIFIED"] = "DISCOUNT_TYPE_UNSPECIFIED";
    /** Discount is a fixed amount in USD. */
    DiscountType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
    /** Discount is a percentage of the total price. */
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
})(DiscountType || (DiscountType = {}));
export var SourceType;
(function (SourceType) {
    /** Default value, can be used when no specific source is associated. */
    SourceType["SOURCE_TYPE_UNSPECIFIED"] = "SOURCE_TYPE_UNSPECIFIED";
    /** Discount is due to Wix/Developer Sale */
    SourceType["SALE"] = "SALE";
    /** Discount is due to App Benefit */
    SourceType["APP_BENEFIT"] = "APP_BENEFIT";
})(SourceType || (SourceType = {}));
export var DurationUnit;
(function (DurationUnit) {
    /** unknown interval unit */
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** month */
    DurationUnit["MONTH"] = "MONTH";
    /** year */
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType || (CycleType = {}));
export var BillingSource;
(function (BillingSource) {
    BillingSource["UNKNOWN"] = "UNKNOWN";
    /** plan billing and charges is managed by Wix */
    BillingSource["WIX"] = "WIX";
    /** plan billing and charges is managed by the app */
    BillingSource["EXTERNAL"] = "EXTERNAL";
})(BillingSource || (BillingSource = {}));
export var TaxType;
(function (TaxType) {
    TaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxType["VAT"] = "VAT";
    TaxType["GST"] = "GST";
})(TaxType || (TaxType = {}));
//# sourceMappingURL=types.impl.js.map